// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3ryf-","Label":"BuildControl_Label__1hs3I","Less":"BuildControl_Less__1zTe_","More":"BuildControl_More__3Z_zZ"};